import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { FarmService } from "../../../../routes/services/farm.service";
import { GlobalFunction } from "../../../../routes/services/globalFuntion";
import { FramesService } from "../../../../routes/services/frames.service";
import { ConfigurationDeviceService } from "../../../../routes/services/configuration-device.service";
import { StorageService } from "../../../../routes/services/storage.service";
import { GlobalConfigService } from "../../../../routes/services/global-config.service";

@Component({
  selector: "app-configuration",
  templateUrl: "./configuration.html",
  styleUrls: ["./configuration.scss", "../offsidebar.component.scss"]
})
export class ConfigurationOffsidebarComponent implements OnInit, OnChanges {
  @Input() permissions = {
    view_refeed: true,
    view_automatic_test: true
  };
  @Input() farm: any = null;
  @Input() status_test_alert: boolean = false;
  fuzzy_dpi: any = false;
  fuzzy_dpi_saved: any = false;
  ports = [0, 1];
  port = "";
  @Input() mode: number = 0;
  @Input() autimaticTestTime = { hour: 0, minute: 0 };

  scheduleDuration: number = 5;
  scheduleDurationSaved: number = 5;
  scheduleDurationSaving: boolean = false;

  xbeeFrameAmount: number = 50;
  xbeeFrameAmountSaved: number = 50;
  xbeeFrameAmountSaving: boolean = false;

  xbeeFrameTimedelta: number = 30;
  xbeeFrameTimedeltaSaved: number = 30;
  xbeeFrameTimedeltaSaving: boolean = false;

  biometryFrequencyUnit: number = 1;
  biometryFrequencyUnitSaved: number = 1;
  biometryFrequencyValue: number = 1;
  biometryFrequencyValueSaved: number = 1;
  requiredBiometricRegistration: boolean = false;
  requiredBiometricRegistrationSaved: boolean = false;

  parametricFrequencyUnit: number = 1;
  parametricFrequencyUnitSaved: number = 1;
  parametricFrequencyValue: number = 1;
  parametricFrequencyValueSaved: number = 1;
  requiredParametricRegistration: boolean = false;
  requiredParametricRegistrationSaved: boolean = false;

  farmConfigSaving: boolean = false;

  @Output() getFarm = new EventEmitter();

  constructor(
    public farmService: FarmService,
    public globalFunction: GlobalFunction,
    public framesService: FramesService,
    public configurationDeviceService: ConfigurationDeviceService,
    public storageService: StorageService,
    public globalConfigService: GlobalConfigService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mode && !changes.mode.firstChange) {
      this.loadScheduleDuration();
      this.loadXbeeFrameConfig();
    }
    if (changes.farm && !changes.farm.firstChange) {
      this.loadFarmConfiguration();
    }
  }

  ngOnInit(): void {
    this.loadScheduleDuration();
    this.loadXbeeFrameConfig();
    this.loadFarmConfiguration();
  }

  /**
   * Loads the farm configuration thresholds (biometry and parametric frequency) from the backend.
   * Se solicita para todos los roles porque required_pond_testing se cachea en
   * storageService.localValue y lo necesitan tanto admin (para el switch de configuración) como
   * cliente (para la alerta de alimentadores sin testear en feeding.component.ts).
   */
  private loadFarmConfiguration(): void {
    if (this.farm) {
      this.farmService.getFarmConfiguration(this.farm.id, false).subscribe((config) => {
        this.biometryFrequencyUnit = config.biometry_frequency_unit ?? 1;
        this.biometryFrequencyUnitSaved = this.biometryFrequencyUnit;
        this.biometryFrequencyValue = config.biometry_frequency_value ?? 1;
        this.biometryFrequencyValueSaved = this.biometryFrequencyValue;
        this.requiredBiometricRegistration = config.required_biometric_registration ?? false;
        this.requiredBiometricRegistrationSaved = this.requiredBiometricRegistration;
        this.parametricFrequencyUnit = config.parametric_frequency_unit ?? 1;
        this.parametricFrequencyUnitSaved = this.parametricFrequencyUnit;
        this.parametricFrequencyValue = config.parametric_frequency_value ?? 1;
        this.parametricFrequencyValueSaved = this.parametricFrequencyValue;
        this.requiredParametricRegistration = config.required_parametric_registration ?? false;
        this.requiredParametricRegistrationSaved = this.requiredParametricRegistration;
        this.storageService.setRequiredPondTesting(config.required_pond_testing ?? false);
        this.fuzzy_dpi = config.fuzzy_dpi;
        this.fuzzy_dpi_saved = config.fuzzy_dpi;
      });
    }
  }

  /** Loads the SCHEDULE_DURATION global config value from the backend. */
  private loadScheduleDuration(): void {
    if (this.storageService.isAdmin()) {
      this.globalConfigService.getByName("SCHEDULE_DURATION", false).subscribe((config) => {
        if (config) {
          this.scheduleDuration = Number(config.value);
          this.scheduleDurationSaved = Number(config.value);
        }
      });
    }
  }

  /** Loads the XBEE frame config values (amount and timedelta) from the backend. */
  private loadXbeeFrameConfig(): void {
    if (this.storageService.isAdmin()) {
      this.globalConfigService
        .getByName("XBEE_FRAME_QUEUE_DISPATCH_AMOUNT", false)
        .subscribe((config) => {
          if (config) {
            this.xbeeFrameAmount = Number(config.value);
            this.xbeeFrameAmountSaved = Number(config.value);
          }
        });
      this.globalConfigService
        .getByName("XBEE_FRAME_THROTTLING_TIMEDELTA_SECONDS", false)
        .subscribe((config) => {
          if (config) {
            this.xbeeFrameTimedelta = Number(config.value);
            this.xbeeFrameTimedeltaSaved = Number(config.value);
          }
        });
    }
  }

  changeAutomaticTesting(propiety: "status_test_alert" | "use_refeeding") {
    if (this.farm) {
      let obj = {
        [propiety]: !this.farm[propiety]
      };

      if (propiety === "use_refeeding") {
        delete obj.farms;
        this.farmService.patchClientFarm(obj, this.farm.id).subscribe((resp) => {
          this.farm[propiety] = !this.farm[propiety];
        });
      }

      if (propiety === "status_test_alert") {
        this.farmService
          .tasksStatusTestAlert(this.farm.id, {
            value: this.status_test_alert
          })
          .subscribe((resp) => {});
      }
    }
  }
  changePort() {
    if (this.farm) {
      const body = { port: Number(this.port) };
      const query = `?farm_id_in=${this.farm.id}`;
      this.framesService.FramePost("change_port", query, body).subscribe((item) => {});
    }
  }

  changeConfig(prop: "fuzzy_dpi", value: any) {
    const body = {
      [prop]: value
    };
    this.configurationDeviceService.patchConfiguration(this.farm.id, "farm", body).subscribe(
      (resp) => {
        this.fuzzy_dpi_saved = this.fuzzy_dpi;
      },
      (err) => {
        this[prop] = !this[prop];
      }
    );
  }

  setAutomaticTime() {
    let { hour, minute }: any = this.autimaticTestTime;
    const { farm_id } = this.storageService.localValue;
    const farmId = Number(farm_id);

    this.farmService.tasksScheduleTestAlert(farmId, { hour, minute }).subscribe((resp) => {
      this.getFarm.emit(String(farm_id));
    });
  }

  /**
   * Returns true when any biometry threshold field differs from its saved value.
   * @returns Whether the biometry configuration has unsaved changes.
   */
  isBiometryChanged(): boolean {
    return (
      this.biometryFrequencyUnit !== this.biometryFrequencyUnitSaved ||
      this.biometryFrequencyValue !== this.biometryFrequencyValueSaved ||
      this.requiredBiometricRegistration !== this.requiredBiometricRegistrationSaved
    );
  }

  /**
   * Returns true when any parametric threshold field differs from its saved value.
   * @returns Whether the parametric configuration has unsaved changes.
   */
  isParametricChanged(): boolean {
    return (
      this.parametricFrequencyUnit !== this.parametricFrequencyUnitSaved ||
      this.parametricFrequencyValue !== this.parametricFrequencyValueSaved ||
      this.requiredParametricRegistration !== this.requiredParametricRegistrationSaved
    );
  }

  /**
   * Persists the biometry threshold configuration to the backend via PATCH.
   */
  saveBiometryThreshold(): void {
    if (!this.farm || this.farmConfigSaving) {
      return;
    }
    this.farmConfigSaving = true;
    const body = {
      biometry_frequency_unit: this.biometryFrequencyUnit,
      biometry_frequency_value: this.biometryFrequencyValue,
      required_biometric_registration: this.requiredBiometricRegistration
    };
    this.farmService.patchFarmConfiguration(this.farm.id, body).subscribe(
      () => {
        this.biometryFrequencyUnitSaved = this.biometryFrequencyUnit;
        this.biometryFrequencyValueSaved = this.biometryFrequencyValue;
        this.requiredBiometricRegistrationSaved = this.requiredBiometricRegistration;
        this.farmConfigSaving = false;
      },
      () => {
        this.farmConfigSaving = false;
      }
    );
  }

  /**
   * Persists the parametric threshold configuration to the backend via PATCH.
   */
  saveParametricThreshold(): void {
    if (!this.farm || this.farmConfigSaving) {
      return;
    }
    this.farmConfigSaving = true;
    const body = {
      parametric_frequency_unit: this.parametricFrequencyUnit,
      parametric_frequency_value: this.parametricFrequencyValue,
      required_parametric_registration: this.requiredParametricRegistration
    };
    this.farmService.patchFarmConfiguration(this.farm.id, body).subscribe(
      () => {
        this.parametricFrequencyUnitSaved = this.parametricFrequencyUnit;
        this.parametricFrequencyValueSaved = this.parametricFrequencyValue;
        this.requiredParametricRegistrationSaved = this.requiredParametricRegistration;
        this.farmConfigSaving = false;
      },
      () => {
        this.farmConfigSaving = false;
      }
    );
  }

  /**
   * Toggles the required_pond_testing flag and persists it via PATCH.
   */
  changeRequiredPondTesting(): void {
    if (!this.farm) {
      return;
    }
    const newValue = !this.storageService.localValue.required_pond_testing;
    this.farmService.patchFarmConfiguration(this.farm.id, { required_pond_testing: newValue }).subscribe(
      () => {
        this.storageService.setRequiredPondTesting(newValue);
      }
    );
  }

  /**
   * Increments the schedule duration by one second.
   */
  increaseScheduleDuration(): void {
    this.scheduleDuration += 1;
  }

  /**
   * Decrements the schedule duration by one second (minimum 1).
   */
  decreaseScheduleDuration(): void {
    if (this.scheduleDuration > 1) {
      this.scheduleDuration -= 1;
    }
  }

  /**
   * Persists the current scheduleDuration value to the backend via SCHEDULE_DURATION global config.
   */
  saveScheduleDuration(): void {
    this.scheduleDurationSaving = true;
    this.globalConfigService
      .patchByName("SCHEDULE_DURATION", String(this.scheduleDuration))
      .subscribe(
        () => {
          this.scheduleDurationSaved = this.scheduleDuration;
          this.scheduleDurationSaving = false;
        },
        () => {
          this.scheduleDurationSaving = false;
        }
      );
  }

  /**
   * Increments the XBEE frame amount by one.
   */
  increaseXbeeFrameAmount(): void {
    this.xbeeFrameAmount += 1;
  }

  /**
   * Decrements the XBEE frame amount by one (minimum 1).
   */
  decreaseXbeeFrameAmount(): void {
    if (this.xbeeFrameAmount > 1) {
      this.xbeeFrameAmount -= 1;
    }
  }

  /**
   * Persists the XBEE frame amount to the backend via XBEE_FRAME_QUEUE_DISPATCH_AMOUNT global config.
   */
  saveXbeeFrameAmount(): void {
    this.xbeeFrameAmountSaving = true;
    this.globalConfigService
      .patchByName("XBEE_FRAME_QUEUE_DISPATCH_AMOUNT", String(this.xbeeFrameAmount))
      .subscribe(
        () => {
          this.xbeeFrameAmountSaved = this.xbeeFrameAmount;
          this.xbeeFrameAmountSaving = false;
        },
        () => {
          this.xbeeFrameAmountSaving = false;
        }
      );
  }

  /**
   * Increments the XBEE frame timedelta by one.
   */
  increaseXbeeFrameTimedelta(): void {
    this.xbeeFrameTimedelta += 1;
  }

  /**
   * Decrements the XBEE frame timedelta by one (minimum 1).
   */
  decreaseXbeeFrameTimedelta(): void {
    if (this.xbeeFrameTimedelta > 1) {
      this.xbeeFrameTimedelta -= 1;
    }
  }

  /**
   * Persists the XBEE frame timedelta to the backend via XBEE_FRAME_THROTTLING_TIMEDELTA_SECONDS global config.
   */
  saveXbeeFrameTimedelta(): void {
    this.xbeeFrameTimedeltaSaving = true;
    this.globalConfigService
      .patchByName("XBEE_FRAME_THROTTLING_TIMEDELTA_SECONDS", String(this.xbeeFrameTimedelta))
      .subscribe(
        () => {
          this.xbeeFrameTimedeltaSaved = this.xbeeFrameTimedelta;
          this.xbeeFrameTimedeltaSaving = false;
        },
        () => {
          this.xbeeFrameTimedeltaSaving = false;
        }
      );
  }
}
